<template>
  <custom-popup
    v-model="dialog"
    :close-on-confirm="false"
    :cons="cons"
    max-width="450"
  >
    <v-card class="pa-4" flat>
      <v-text-field
        v-model="address"
        :error-messages="errors.identifier"
        :loading="loading"
        :rules="[dtUrlRule]"
        append-icon="mdi-web"
        class="rounded-lg"
        clearable
        dense
        :label="$t('qrAddressUpdate.labels.address')"
        outlined
        persistent-hint
        :hint="$t('qrAddressUpdate.hints.allowedChars')"
        @keydown.enter="updateAddress"
      />
      <v-expand-transition>
        <div
          v-if="hasInvalidChars"
          class="d-flex justify-end mb-2 pr-2"
          style="margin-top: -10px"
        >
          <v-btn
            class="rounded-lg btn-edit ma-2"
            x-small
            outlined
            rounded
            @click="cleanInvalidChars"
          >
            <v-icon left small>mdi-auto-fix</v-icon>
            {{ $t('qrAddressUpdate.buttons.removeInvalidChars') }}
          </v-btn>
        </div>
      </v-expand-transition>

      <!-- Uncomment if you want to include the warning text -->
      <!--
      <v-card-text class="font-size-h6 line-height-lg">
        <b class="red--text">{{ $t('qrAddressUpdate.warning') }}</b>
        {{ $t('qrAddressUpdate.warningMessage') }}
        <br>
        {{ $t('qrAddressUpdate.savePrompt') }}
      </v-card-text>
      -->
    </v-card>
  </custom-popup>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "qrAddressUpdate",

  props: {
    value: Boolean,
  },

  data() {
    return {
      address: null,
      errors: {},
      loading: false,
    };
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    hasInvalidChars() {
      if (!this.address) return false;
      return /[^a-zA-Z0-9\-_]/.test(this.address);
    },

    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    slug() {
      return this.$route.params;
    },
    canMore() {
      return this.dtUrlRule(this.address) === true;
    },
    cons() {
      return {
        title: this.$t("qrAddressUpdate.title"),
        buttons: [
          {
            type: "submit",
            handler: this.updateAddress,
            disabled: () => !this.canMore,
          },
        ],
      };
    },
    dtUrlRule() {
      return (v) => {
        if (!v || v.length < 3) {
          return this.$t("qrAddressUpdate.errors.minLength");
        }
        const isValid = /^[a-zA-Z0-9\-_]+$/.test(v);
        if (!isValid) {
          return this.$t("qrAddressUpdate.errors.invalidChars");
        }

        return true;
      };
    },
  },

  mounted() {
    this.address = this.slug.id;
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    cleanInvalidChars() {
      if (this.address) {
        this.address = this.address.replace(/[^a-zA-Z0-9\-_]/g, "");
      }
    },
    updateAddress() {
      if (!this.canMore) {
        return this.$toast.error(
          this.$t("qrAddressUpdate.errors.invalidAddress"),
        );
      }

      this.errors = {};
      this.loading = true;

      this.$api
        .put(`/v1/testQr/identifier/${this.createQrID}`, {
          identifier: this.address,
        })
        .then(({ data }) => {
          this.$toast.success(
            data.message || this.$t("qrAddressUpdate.successMessage"),
          );
          this.$router.replace({
            name: this.$route.name,
            params: { name: this.slug.name, id: data.data },
          });
          this.dialog = false;
          this.$emit("reload", data.data);
        })
        .catch(({ response }) => {
          this.$toast.error(this.$t("qrAddressUpdate.errors.updateFailed"));

          if (response?.data?.errors) {
            this.errors = response.data.errors;
          }
        })
        .finally(() => (this.loading = false));
    },
    isURL(str) {
      let regex = new RegExp("^[a-zA-Z0-9\\-_~:?#[\\]@!$&'()+,;=.]+$");
      return regex.test(str);
    },
  },
};
</script>

<style scoped></style>
